import EdgeStyleContainer from '../../../Componant/Buttons/EdgeStyle/EdgeStyle'

const EdgeStyle = () => {
  return (
    <div className='page-body'>
      <EdgeStyleContainer />
    </div>
  )
}

export default EdgeStyle